<template>
    <div>
        <div class="page-title">
            <h4> {{$t('txt.editeazaAngajat')}}</h4>
        </div>
        <form class="add-user-form" id='edit-employee' method="POST">
          <div class="type-person">
              <div class="col-12">
                  <div class="location-header">
                      <h4> {{$t('txt.tipulDePersoana')}} </h4>
                  </div>
                  <div class="col-12">
                      <label class="container_check">
                          <input type="radio" value="1" name="type" v-model="type_employee">
                          <span class="checkmark"></span>
                          {{$t('txt.persFizica')}}
                      </label>
                  </div>
                  <div class="col-12">
                      <label class="container_check">
                          <input type="radio" value="2" name="type" v-model="type_employee">
                          <span class="checkmark"></span>
                          {{$t('txt.persJuridica')}}
                      </label>
                  </div>
              </div>
          </div>
            <input type="hidden" name="_method" value="put" />
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group"
                         v-for="input_field in input_fields.column_1"
                         :key="input_field.id">
                         <div class="inputfield-wrapper" v-if="!input_field.personType || parseInt(input_field.personType) === parseInt(type_employee)">
                           <input type="text" class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   v-model="input_field.inputValue"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName">
                           <label class=""> {{input_field.labelName}} </label>
                           <span class="focus-input"></span>
                           <span class="symbol-input">
                             <i v-bind:class="input_field.icon"></i>
                           </span>
                           <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                         </div>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 col-12">
                    <div class="form-group" v-for="input_field in input_fields.column_2" :key="input_field.id">
                        <div class="selections-option" v-if="input_field.inputName === 'county'" @click="selected_label = 1">
                            <label :class="{select_label_class:selected_label == 1}">Alege Judetul </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label == 1}">
                                <i class="fas fa-city"></i>
                            </div>
                            <v-select v-model="select_county"
                                      :options="counties"
                                      label="name"
                                      @input="getCitiesByCounty()">
                            </v-select>
                        </div>
                        <div class="selections-option" v-else-if="input_field.inputName === 'city'" @click="selected_label = 2">
                            <label :class="{select_label_class:selected_label == 2}"> Alege Orasul </label>
                            <div class="symbol-input" :class="{symbol_input_class:selected_label == 2}">
                                <i class="fas fa-city"></i>
                            </div>
                                <v-select v-model="select_city"
                                          :options="cities"
                                          label="name">
                                </v-select>
                        </div>
                        <div v-else>
                            <input type="text"
                                   class="form-control"
                                   placeholder=""
                                   v-validate="input_field.validationRules"
                                   :name="input_field.inputName"
                                   :data-vv-as="input_field.labelName"
                                   :id="input_field.inputName"
                                   v-model="input_field.inputValue">
                            <label class=""> {{input_field.labelName}} </label>
                            <span class="focus-input"></span>
                            <span class="symbol-input">
                                <i v-bind:class="input_field.icon"></i>
                            </span>
                        </div>
                        <p class="custom-error-info"> {{errors.first(input_field.inputName)}} </p>
                    </div>
                </div>
                <div v-if="!this.has_account" class="alert-checkbox-container">
                    <label class="alert-checkbox">
                            <input type="checkbox" value='1' name="create_account">
                            <span class="checkbox-material">
                            <span class="check"></span>
                        </span>
                        <p> {{$t('txt.creeazaCont')}} </p>
                    </label>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.depozite')}} </h4>
                    </div>
                </div>
                <warehouses :select="this.warehouses"></warehouses>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaTipAngajat')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <subtypes :subtypes="employeeSubtypes"></subtypes>
                    <!--<v-select :options="employeeSubtypes" v-model="selectedEmployeeSubtype" placeholder="Selecteaza tip" label="name"></v-select>-->
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.roluri')}} </h4>
                    </div>
                </div>
                <roles :roles="roles" :type="'employee'" :user="employee"/>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <b-form-file
                                name="files[]"
                                v-model="file"
                                ref="file-input"
                                :state="Boolean(file)"
                                placeholder="Alege Fisierul..."
                                drop-placeholder="Drop file here..."
                                id='file'
                                multiple
                        ></b-form-file>
                        <div class="documents-list" v-if="this.employee">
                            <div class="document-box" v-for="(file, index) in this.employee.files" :key="index">
                                <div class="delete-doc" @click='removeMedia(index, file.id)'>
                                    <i class="far fa-times-circle"></i>
                                </div>
                                <div class="document-content">
                                    <i class="far fa-file-alt"></i>
                                    <section v-if="mimes.includes(file.mime)">
                                        <a v-bind:href="file.link" target="_blank"> {{ file.file_name }} </a>
                                    </section>
                                    <section v-else>
                                        <a :href="file.link" download> {{ file.file_name }} </a>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea v-model="this.notes" :placeholder="$t('placeholder.notite')" name='notes'></textarea>
                        <div class="save-contact-buttons">
                            <button type="button" @click='saveEmployee()'>
                                <i class="fas fa-check"></i>
                                {{$t('placeholder.salveaza')}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import EmployeeService from '../../api-services/employees.service.js'
import CountiesService from '../../api-services/counties.service.js'
import RolesService from '../../api-services/roles.service.js'
import LocationsService from '../../api-services/locations.service.js'
import ContactsService from '../../api-services/contacts.service.js'
import UsersService from '../../api-services/users.service.js'
import Subtypes from '../subtypes/Subtypes.vue'
import Warehouse from '../warehouse/Warehouse.vue'
import Roles from '../../components/Roles.vue'
import { syncPartners } from '../../sync/sync'

import localforage from 'localforage'
export default {
  name: 'Editemployee',
  data () {
    return {
      employee: {
        personType: 1,
        id: null,
        type: null,
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        phone: null,
        county: null,
        city: null,
        address: null,
        cui: null,
        nr_reg: null,
        bank: null,
        site: null,
        delegat: null,
        date_corespondenta: null,
        notes: null,
        has_account: null,
        locations: null,
        contacts: null,
        files: null
      },
      type_employee: null,
      has_account: true,
      notes: null,
      selected_label: undefined,
      file: null,
      mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
      locationStatus: false,
      contactStatus: false,
      counties: [],
      cities: [],
      select_county: null,
      select_city: null,
      post_data: [],
      selected: null,
      employeeSubtypes: [],
      selectedEmployeeSubtype: null,
      warehouses: [],
      roles: []
    }
  },
  components: {
    'subtypes': Subtypes,
    'warehouses': Warehouse,
    'roles': Roles
  },
  methods: {
    getRoles () {
      RolesService.getAll()
        .then((response) => {
          this.roles = response.data.data
          // employee default - look in mixins
          for (let i = 0; i < this.employee.roles.length; i++) {
            this.checkUserDefaultRole(this.roles, this.employee.roles[i])
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    clearFiles () {
      this.$refs['file-input'].reset()
    },
    getWarehouses () {
      EmployeeService.getWarehouses()
        .then((response) => {
          this.warehouses = response.data.data.data
          for (let i = 0; i < this.warehouses.length; i++) {
            let userWarehouse = this.employee.warehouses.find(empWarehouse => parseInt(empWarehouse.id) === this.warehouses[i].id)
            if (userWarehouse) {
              this.warehouses[i].value = true
            } else {
              this.warehouses[i].value = false
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getEmployee () {
      return new Promise((resolve, reject) => {
        EmployeeService.get(this.$route.params.id)
          .then((response) => {
            this.employee = response.data.data
            this.type_employee = this.employee.type
            this.has_account = this.employee.has_account
            this.notes = this.employee.notes
            this.$store.dispatch('hideLoading')
            resolve(response)
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('hideLoading')
            reject(error)
          })
      })
    },
    getEmployeeSubtypes () {
      EmployeeService.getTypes()
        .then((response) => {
          this.employeeSubtypes = response.data.data
          for (let i = 0; i < this.employeeSubtypes.length; i++) {
            let employeeSubtypes = this.employee.user_type.find(employeeSubtype => parseInt(employeeSubtype.type_id) === this.employeeSubtypes[i].id)
            if (employeeSubtypes) {
              this.employeeSubtypes[i].value = true
            } else {
              this.employeeSubtypes[i].value = false
            }
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getCounties () {
      return localforage.getItem('counties').then((response) => {
        this.counties = response
        if (this.employee.county) {
          this.select_county = this.counties.find(county => parseInt(county.id) === parseInt(this.employee.county.id))
          this.getCitiesByCounty()
        }
      })
    },
    getCitiesByCounty () {
      let countyId = this.select_county.id
      if (countyId && countyId > 0) {
        return localforage.getItem('cities').then((response) => {
          this.cities = response
          if (this.employee.city) {
            this.select_city = this.cities.find(city => parseInt(city.id) === parseInt(this.employee.city.id))
          }
        })
      }
    },
    async saveEmployee () {
      let validatorResp = true
      await this.$validator.validateAll().then((result) => {
        validatorResp = result
        if (this.$validator.errors && !result) {
          let input = document.getElementById(this.$validator.errors.items[0].field)
          window.scrollTo(0, input.offsetTop - 50)
        }
      })
      if (!validatorResp) {
        return
      }
      this.$store.dispatch('showLoading')
      let formData = new FormData(document.getElementById('edit-employee'))
      // console.log(formData.get('files[]'),'form-data');
      if (this.select_county) {
        formData.append('county', this.select_county.id)
      }
      if (this.select_city) {
        formData.append('city', this.select_city.id)
      }

      let roleId = this.roles.filter(function (role) {
        if (role.value) {
          return role.name
        }
      })
      formData.append('roles', JSON.stringify(roleId))
      formData.append('subtypes', JSON.stringify(this.employeeSubtypes))
      formData.append('warehouses', JSON.stringify(this.warehouses))

      EmployeeService.update(this.$route.params.id, formData)
        .then((response) => {
          syncPartners()
          this.$store.dispatch('showLoading')
          this.employee = response.data.data
          this.notes = this.employee.notes
          document.getElementById('file').value = ''
          this.$refs['file-input'].reset()
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.angajatModificat'),
            'animation-type': 'css'
          })
          window.scrollTo(0, 0)
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          if (error.response && typeof error.response.data.error === 'object') {
            this.$store.dispatch('showLoading')
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('error.errorTitle'),
              text: this.$t('error.validationError'),
              'animation-type': 'css'
            })
            const entries = Object.entries(error.response.data.error)
            let lastKey
            for (const [key, err] of entries) {
              lastKey = key
              const field = this.$validator.fields.find({ name: key, scope: this.$options.scope })
              if (!field) continue
              this.$validator.errors.add({
                id: field.id,
                field: key,
                msg: err[0],
                scope: this.$options.scope
              })
              field.setFlags({
                invalid: true,
                valid: false,
                validated: true
              })
            }
            let input = document.getElementById(lastKey)
            console.log(input)
            console.log(input.offsetTop)
            console.log(lastKey)
            window.scrollTo(0, input.offsetTop - 50)
          } else {
            this.$notify({
              group: 'error',
              type: 'error',
              title: this.$t('errors.errorTitle'),
              text: error.response.data.error,
              'animation-type': 'css'
            })
          }

          this.$store.dispatch('hideLoading')
        })
    },
    saveLocation () {
      let locationObj = {}
      this.input_fields.location.forEach(function (element) {
        let key = [element.inputName]
        locationObj[key] = element.inputValue
      })

      EmployeeService.addLocation(this.$route.params.id, locationObj)
        .then((response) => {
          this.employee.locations.push(response.data.data)
          this.locationStatus = !this.locationStatus
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveContact () {
      let contactObj = {}
      this.input_fields.contact.forEach(function (element) {
        let key = [element.inputName]
        contactObj[key] = element.inputValue
      })
      console.log(contactObj)
      EmployeeService.addContact(this.$route.params.id, contactObj)
        .then((response) => {
          this.employee.contacts.push(response.data.data)
          this.contactStatus = !this.contactStatus
        })
        .catch((error) => {
          console.log(error)
        })
    },
    removeLocation (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeLocatia'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          LocationsService.delete(id)
            .then((response) => {
              this.$delete(this.employee.locations, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Locatia a fost stearsa cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    removeContact (index, id) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeContactul'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          ContactsService.delete(id)
            .then((response) => {
              this.$delete(this.employee.contacts, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Contactul a fost sters cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    },
    removeMedia (index, mediaId) {
      this.$swal.fire({
        title: this.$t('txt.suntetiSigur'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('txt.stergeFisierul'),
        cancelButtonText: this.$t('txt.anuleaza')
      }).then((result) => {
        if (result.value) {
          UsersService.delete(this.$route.params.id, mediaId)
            .then((response) => {
              this.$delete(this.employee.files, index)
              this.$notify({
                group: 'succes',
                type: 'success',
                title: 'DELETED',
                text: 'Fisiserul a fost stears cu succes!',
                'animation-type': 'css'
              })
            })
            .catch((error) => {
              let message = error.response.data.error
              this.$notify({
                group: 'error',
                type: 'error',
                title: 'Error',
                text: message,
                'animation-type': 'css'
              })
            })
        }
      })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.employee) ? this.employee.first_name : '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.employee) ? this.employee.last_name : '',
            icon: 'fas fa-signature',
            validationRules: 'required',
            personType: 1
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: (this.employee) ? this.employee.cnp : '',
            icon: 'far fa-id-card',
            validationRules: 'min:13|max:13|numeric',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: (this.employee) ? this.employee.ci_series : '',
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: (this.employee) ? this.employee.ci_number : '',
            icon: 'far fa-id-card',
            validationRules: '',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.employee) ? this.employee.company_name : '',
            icon: 'fas fa-building',
            validationRules: 'required',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.employee) ? this.employee.phone : '',
            icon: 'fas fa-phone',
            validationRules: ''
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.employee) ? this.employee.cui : '',
            icon: 'fas fa-scroll',
            validationRules: ''
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.employee) ? this.employee.nr_reg : '',
            icon: 'fas fa-cash-register',
            validationRules: ''
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.employee) ? this.employee.bank : '',
            icon: 'fas fa-piggy-bank',
            validationRules: ''
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.employee) ? this.employee.county : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.employee) ? this.employee.city : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.employee) ? this.employee.address : '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.employee) ? this.employee.email : '',
            icon: 'fas fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'delegat',
            labelName: this.$t('placeholder.delegat'),
            inputValue: (this.employee) ? this.employee.delegat : '',
            icon: 'fas fa-user-tie',
            validationRules: ''
          },
          {
            inputName: 'date_corespondenta',
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            inputValue: (this.employee) ? this.employee.date_corespondenta : '',
            icon: 'fas fa-info',
            validationRules: ''
          },
          {
            inputName: 'site',
            labelName: this.$t('placeholder.siteWeb'),
            inputValue: (this.employee) ? this.employee.site : '',
            icon: 'far fa-window-maximize',
            validationRules: ''
          }
        ],
        location: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.denumireLocatie'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: '',
            icon: 'fas fa-map-marker-alt',
            validationRules: ''
          },
          {
            inputName: 'link_map',
            labelName: this.$t('placeholder.linkGoogleMaps'),
            inputValue: '',
            icon: 'fas fa-map-marked',
            validationRules: ''
          },
          {
            inputName: 'contact_pers',
            labelName: this.$t('placeholder.persoanaContact'),
            inputValue: '',
            icon: 'fas fa-users-cog',
            validationRules: ''
          }
        ],
        contact: [
          {
            inputName: 'name',
            labelName: this.$t('placeholder.nume'),
            inputValue: '',
            icon: 'fas fa-signature',
            validationRules: ''
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: '',
            icon: 'fas fa-phone',
            validationRules: ''
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: '',
            icon: 'fa fa-envelope',
            validationRules: 'email'
          },
          {
            inputName: 'function',
            labelName: this.$t('placeholder.functie'),
            inputValue: '',
            icon: 'far fa-id-badge',
            validationRules: ''
          },
          {
            inputName: 'notes',
            labelName: this.$t('placeholder.notite'),
            inputValue: '',
            icon: '',
            validationRules: ''
          }
        ]
      }
    }
  },
  async created () {
    await this.getEmployee()
    await this.getRoles()
    this.getEmployeeSubtypes()
    this.getCounties()
    this.getWarehouses()
  }
}
</script>
